import React from "react";
import "./Loader.css";
import Icon32Spinner from '@vkontakte/icons/dist/32/spinner';
import {motion} from "framer-motion";

let Loader = (props) => {
        return(
            <motion.div initial={{scale:1.1,opacity:0}} animate={{opacity: [0,1], scale:[1.1,1]}} className="Loader">
                <motion.div animate={{rotate:360}} transition={{loop:Infinity, duration:0.5, ease:"linear"}}>
                    <Icon32Spinner/>
                </motion.div>
            </motion.div>
        );
}

export default Loader;